import React from "react";
import { Helmet } from "react-helmet";
// import { ThemeProvider } from "styled-components";
import { ThemeProvider } from "styled-components";
import "../styles/reset.css";

import colors from "../config/colors";
import useSiteMetadata from "./SiteMetadata";
import { withPrefix } from "gatsby";

const TemplateWrapper = ({ children }) => {
  const { title, description } = useSiteMetadata();
  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="facebook-domain-verification" content="xfp1s93c1yvx9m2858yq4ywxoo5pvs" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix("/")}img/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-32x32.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-16x16.png`}
          sizes="16x16"
        />
        <link
          rel="prefetch stylesheet"
          href={`${withPrefix("/")}fonts/fonts.css`}
        />

        <meta name="theme-color" content="#fff" />

        <meta property="og:type" content="business.business" />
        <meta property="og:title" content={title} />
        <meta property="og:url" content="/" />
        <meta
          property="og:image"
          content={`${withPrefix("/")}img/og-image.jpg`}
        />

      </Helmet>
      <ThemeProvider theme={colors}>
        <div>{children}</div>
      </ThemeProvider>
    </div>
  );
};

export default TemplateWrapper;
